<template>
  <section class="section-reports">
    <header>
      <Mural
        :breadcrumbs="breadcrumbs"
        :notificationQuantity="0"
        route="home"
        :query="{}"
      />
      <TabNavigation
        class="q-py-sm"
        :tabs="tabs"
        :selectTab="tab"
        @selectedTabs="(value) => changeTab(value)"
      />
    </header>
    <section class="content-report q-py-md">
      <main class="q-px-md">
        <!-- <h4>Escolha os filtros para gerar os relatórios</h4> -->
        <div class="box-form-filter q-py-md">
          <PostPage v-if="tab == 1" @historyList="(value) => test(value)" />
          <CoursePage v-if="tab == 2" />
          <UsersPage v-if="tab == 3" />
          <WikiPage v-if="tab == 4" />
          <LightningTestPage v-if="tab == 5" />
          <MoodPage v-if="tab == 6" />
        </div>
      </main>
    </section>
  </section>
</template>

<script>
//----COMPONENTS
import TabNavigation from "@/components/reports/TabNavigation.vue";
import Mural from "@/components/Mural.vue";

import PostPage from "@/pages/admin/history/pages/FeedPage.vue";
import CoursePage from "@/pages/admin/history/pages/CoursePage.vue";
import UsersPage from "@/pages/admin/history/pages/UsersPage.vue";
import WikiPage from "@/pages/admin/history/pages/WikiPage.vue";
import LightningTestPage from "@/pages/admin/history/pages/LightningTestPage.vue";
import MoodPage from "./pages/MoodPage.vue";

//----SERVICES
//----UTILS
import CanUserAccessClass from "@/utils/CanUserAccessClass";

//----VUEJS
import {onMounted, ref} from "vue";

export default {
  components: {
    TabNavigation,
    PostPage,
    CoursePage,
    UsersPage,
    WikiPage,
    MoodPage,
    LightningTestPage,
    Mural,
  },
  setup() {
    //------SERVICES

    const canUserAccessClass = new CanUserAccessClass();

    //------CONSTATNS
    const tabs = ref([
      {
        value: 1,
        name: "Posts",
        permission: !validateActionsPage("analytic-history-posts"),
      },
      {
        value: 2,
        name: "Cursos",
        permission: !validateActionsPage('analytic-history-courses'),
      },
      {
        value: 3,
        name: "Usuários",
        permission: !validateActionsPage("analytic-history-users"),
      },
      {
        value: 4,
        name: "Wiki",
        permission: !validateActionsPage("analytic-history-wikis"),
      },
      {
        value: 5,
        name: "Teste Relâmpago",
        permission: !validateActionsPage("analytic-history-lightning"),
      },
      {
        value: 6,
        name: "Humor",
        permission: !validateActionsPage("analytic-history-humor"),
      },
    ]);


    //------VARIABLES
    let tab = ref(1);
    let breadcrumbs = ref(["Histórico"]);
    let isShowFilter = ref(false);
    let listHistoryData = ref([]);



    function handlePermissionsForTabs() {
      tab.value = tabs.value.find(tab => tab.permission === false).value
    }

    async function test(value) {
      listHistoryData.value = await value();
    }

    function validateActionsPage(routeName) {
      if (!canUserAccessClass.canUserAccess(routeName, false)) {
        return false;
      }
      return true;
    }

    function changeTab(value) {
      tab.value = value;
    }

    async function validateForm(form) {
      console.log(form);
    }

    onMounted(() => {
      handlePermissionsForTabs()
    });

    return {
      //-----CONSTANTS

      //-----VARIABLES
      tab,
      tabs,
      breadcrumbs,
      isShowFilter,
      listHistoryData,

      //-----FUNCTIONS
      changeTab,
      validateForm,
      validateActionsPage,
      test,
    };
  },
};
</script>

<style lang="scss" scoped>
.section-reports {
  width: 100%;
  height: 100%;
  padding: 16px;
}
.content-report {
  max-height: 79%;
  overflow-y: auto;

  main {
    overflow-y: auto;

    h5 {
      font-style: normal;
      font-weight: 700;
      font-size: 18px;
      line-height: 22px;
      color: #2f2f2f;
      font-family: Montserrat;
    }

    h4 {
      font: 1.2rem "Montserrat", sans-serif;
    }

    .box-form-filter {
      // height: 65vh;
      overflow-y: auto;
      //border: 1.5px solid #C4C4C4;
      // box-shadow: 3px 3px 8px rgba(196, 196, 196, 0.15);
      // border-radius: 50px;
    }
  }
}

.title-filter {
}
</style>
